module.exports = __webpack_public_path__ + "img/zhengshu.14ddf2af.jpg";